module.exports = __webpack_public_path__ + "static/media/logo_login.956b3d28.jpg";